import { Component } from '@angular/core';
import "@maersk-global/mds-components-core/mc-card";
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-un-athourised',
  templateUrl: './un-athourised.component.html',
  styleUrls: ['./un-athourised.component.scss']
})
export class UnAthourisedComponent {
  constructor(private router:Router, private authService:MsalService) {

  }
}
